import { Description } from '@mui/icons-material';
import { Box, Typography, alpha } from '@mui/material';
import { DiscountType } from '@trnsact/trnsact-shared-types';
import type { Attachment } from 'modules/equipment';
import { formatCurrency } from 'utils';
import { InfoListCard, InfoListRow } from './InfoListCard';

interface Props {
  attachments: Attachment[];
}

const getDiscountedUnitPrice = ({ retailPrice, discountValue, discountType }: Attachment): number =>
  discountType === DiscountType.Percent
    ? retailPrice - (retailPrice * (discountValue ?? 0)) / 100
    : retailPrice - (discountValue ?? 0);

const getAttachmentLabel = ({ type, manufacturer, model }: Attachment): string =>
  [type, manufacturer, model].filter(Boolean).join(' ');

export const AttachmentsCard = ({ attachments }: Props) => {
  if (attachments.length === 0) return null;

  const total = attachments.reduce((sum, attachment) => sum + getDiscountedUnitPrice(attachment), 0);

  const rows: InfoListRow[] = attachments.map((attachment, index) => ({
    key: `${attachment.model}-${index}`,
    label: getAttachmentLabel(attachment),
    value: formatCurrency(getDiscountedUnitPrice(attachment), true),
  }));

  return (
    <InfoListCard
      icon={<Description color="primary" fontSize="small" />}
      title="Attachments"
      count={attachments.length}
      badge={
        <Box px={1} py={0.25} borderRadius={1} sx={{ bgcolor: theme => alpha(theme.palette.primary.main, 0.1) }}>
          <Typography variant="body2" fontWeight={600} color="primary.main">
            {formatCurrency(total, true)}
          </Typography>
        </Box>
      }
      rows={rows}
    />
  );
};
